<template>
    <div class="container">
        <div id="login">
            <h1>Login</h1>
            <input type="text" name="username" v-model="input.username" placeholder="Username"/>
            <input type="password" name="password" v-model="input.password" placeholder="Password"/>
            <button type="button" v-on:click="login()">Login</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "loginPage",
        components: {},
        props: ['mockAccount'],
        data() {
            return {
                input: {
                    username: "",
                    password: "",
                }
            }
        },
        methods: {
            login() {
                if (this.input.username != "" && this.input.password != "") {
                    var formData = new FormData();
                    formData.append('username', this.input.username);
                    formData.append('password', this.input.password);
                    this.$http.post("http://game.dokamar.cz/login.php", formData, {withCredentials: true})
                        .then(function (data) {
                            console.log(data)
                            this.remaining = data.body
                        });
                } else {
                    console.log("A username and password must be present");
                }
            },
        }
    }
</script>

<style scoped>
    #login {
        width: 500px;
        border: 1px solid #CCCCCC;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 200px;
        margin-bottom: 200px;
        padding: 20px;
    }
</style>